<template>
	<div>
		<div>
			<div style="font-size:20px;float:left;margin:-40px 0 0 40px;font-weight:600">
				代岗申请-{{ ruleForm.id === null || ruleForm.id === '' ? '新增' : '修改' }}</div>
			<el-button
				style="float: right; height: 40px; margin-top: -40px; margin-right: 40px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
				@click="Return">返回</el-button>

			<!-- 主体 -->
			<div style="height:750px;background-color:white;margin:75px 40px 0 40px;overflow-x: hidden">
				<!-- 查询框 -->
				<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="180px" class="demo-ruleForm">
					<el-row>
						<el-col :span="12">
							<el-form-item label="组织架构" prop="spare5" style="margin-top:30px;">
								<el-cascader v-model="ruleForm.spare5" clearable style="width: 100%" collapse-tags
									:props="props"></el-cascader>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="12">
							<el-form-item label="城市" prop="city_id">
								<el-select v-model="ruleForm.city_id" style="width:100%" placeholder="请选择" clearable>
									<el-option v-for="item in $globals.cityList" :key="item.city" :label="item.city"
										:value="item.city">
									</el-option>
								</el-select>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="12">
							<div @click="StaffFind">
								<el-form-item label="代岗人" prop="replace_staff_name">
									<el-input style="width:100%" v-model="ruleForm.replace_staff_name"
										onfocus="this.blur();"></el-input>
								</el-form-item>
							</div>
						</el-col>
					</el-row>

					<!-- <el-row>
						<el-col :span="12">
							<el-form-item label="职位" prop="post_id">
								<el-input v-model="ruleForm.post_name" :disabled="true" style="width:100%"></el-input>
							</el-form-item>
						</el-col>
					</el-row> -->

					<el-row>
						<el-col :span="12">
							<el-form-item label="代岗原因" prop="replace_reason">
								<el-input type="textarea" :rows="2" placeholder="请输入代岗原因"
									v-model="ruleForm.replace_reason" style="width:100%">
								</el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="12">
							<el-form-item label="类别" prop="replace_type">
								<el-select v-model="ruleForm.replace_type" style="width:100%" placeholder="请选择" clearable>
									<el-option v-for="item in lbList" :key="item.label" :label="item.label"
										:value="item.label">
									</el-option>
								</el-select>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="12">
							<el-form-item label="代岗开始时间" prop="start_date">
								<el-date-picker v-model="ruleForm.start_date" style="width:100%" type="datetime"
									format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" placeholder="选择日期时间">
								</el-date-picker>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="12">
							<el-form-item label="代岗结束时间" prop="end_date">
								<el-date-picker v-model="ruleForm.end_date" style="width:100%" type="datetime"
									format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" placeholder="选择日期时间">
								</el-date-picker>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="12">
							<el-form-item label="天数" prop="replace_days">
								<el-input type="number" v-model="ruleForm.replace_days" placeholder="请输入天数"
									style="width:100%">
								</el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="12">
							<el-form-item label="元/天" prop="day_price">
								<el-input type="number" v-model="ruleForm.day_price" placeholder="请输入元/天"
									style="width:100%">
								</el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="12">
							<el-form-item label="总金额" prop="total_amount">
								<el-input type="number" v-model="ruleForm.total_amount" placeholder="请输入总金额"
									style="width:100%">
								</el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-form-item label-width="0" style="margin-left: 22%;">
						<el-button type="goon" @click="AddAuditor()"
							v-show="ruleForm.id === null || ruleForm.id === ''">保存</el-button>
						<el-button type="goon" @click="UpdateAuditor()"
							v-show="ruleForm.id != null && ruleForm.id != ''">修改</el-button>
						<el-button type="addbtn" @click="resetForm('ruleForm')">重置</el-button>
					</el-form-item>
				</el-form>

			</div>

		</div>

		<el-dialog title="代岗人" :visible.sync="dialogVisible" width="40%" :center="true" :close-on-click-modal="false"
			:show-close="false">
			<el-row>
				<organizeStaff ref="organizeStaff" type="checkbox" :accordion="false" @commit="saveChange"
					:staff_id_prop="object.staff_id"></organizeStaff>
			</el-row>
			<el-row style="text-align: center;">
				<el-button type="goon" style="margin-top: 10px;" @click="$refs['organizeStaff'].commit()">确定</el-button>
			</el-row>
		</el-dialog>

		<!-- <el-dialog title="选择审核人" :visible.sync="dialogAuditorVisible" width="40%" :center="true"
			:close-on-click-modal="false">
			<SelectAuditor ref="SelectAuditor" :type="5" :examineDetailsList="ruleForm.examineDetailsList"
				:id="ruleForm.id"></SelectAuditor>
		</el-dialog> -->

	</div>
</template>

<script>
import organizeStaff from '../../utils/organizeStaff/organizeStaff.vue';
// import SelectAuditor from '../SelectAuditor/SelectAuditor.vue';
export default {
	components: {
		organizeStaff: organizeStaff,
		// SelectAuditor: SelectAuditor,
	},
	props: ["organizeList"],
	data() {
		var organizeFind = async (e, spare8) => {
			var organizeList = await this.$globals.AxiosPost("organize/findHierarchy", {
				identification: "1",
				organize_id: e,
				spare8: spare8,
			});
			return organizeList.data;
		};
		return {
			//表单数据
			ruleForm: {
				id: '',
				spare5: [],
				project_id: "",
				city_id: '',
				post_id: '',
				post_name: '',
				replace_staff: [],
				replace_staff_name: '',
				replace_reason: '',
				start_date: '',
				end_date: '',
				replace_days: '',
				day_price: '',
				total_amount: '',
				examineDetailsList: [],
				replace_type: '',

			},

			//暂存数据
			object: {
				staff_id: "",
				staff_name: "",
				project_id: "",
				project_name: ""
			},

			//表单验证
			rules: {
				spare5: [{
					required: true,
					message: '请选择组织架构！',
					trigger: 'blur'
				}],
				city_id: [{
					required: true,
					message: '请选择城市！',
					trigger: 'blur'
				}],
				replace_staff_name: [{
					required: true,
					message: '请选择代岗人！',
					trigger: 'blur'
				}],
				replace_reason: [{
					required: true,
					message: '请输入代岗原因！',
					trigger: 'blur'
				}],
				start_date: [{
					required: true,
					message: '请选择开始时间！',
					trigger: 'blur'
				}],
				end_date: [{
					required: true,
					message: '请选择结束时间！',
					trigger: 'blur'
				}],
				replace_days: [{
					required: true,
					message: '请输入天数！',
					trigger: 'blur'
				}],
				day_price: [{
					required: true,
					message: '请输入元/天！',
					trigger: 'blur'
				}],
				total_amount: [{
					required: true,
					message: '请输入总金额！',
					trigger: 'blur'
				}],
				replace_type: [{
					required: true,
					message: '请选择类别！',
					trigger: 'blur'
				}],
			},

			//级联下拉配置
			props: {
				lazy: true,
				async lazyLoad(node, resolve) {
					if (node.level === 0) {
						return resolve(await organizeFind('', 'group'));
					} else {
						resolve(await organizeFind(node.data.id, ''));
					}
				},
				value: "id",
				label: "organize_name",
				children: "organizeList",
				checkStrictly: true,
				multiple: false,
			},
			lbList: [{ label: "代岗" }, { label: "加班" }],
			//页面相关
			dialogVisible: false,
			dialogAuditorVisible: false

		};
	},
	methods: {
		StaffFind() {
			this.dialogVisible = true;
			this.showtxbm = true;
			this.staffList.forEach(item => {
				if (item.id === this.ruleForm.staff_id) {
					this.ruleForm.post_id = item.post_id;
					this.ruleForm.post_name = item.post_name;
				}
			})
		},
		//设置确定
		saveChange(e) {
			this.ruleForm.replace_staff = e.staff_ids;
			this.ruleForm.replace_staff_name = e.staff_name;
			this.ruleForm.post_name = e.staff[0].post_name;
			this.dialogVisible = false;
		},
		//添加
		AddAuditor() {
			this.$refs["ruleForm"].validate((valid) => {
				if (valid) {
					this.Add()
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		async Add() {
			var spare5 = "";
			this.ruleForm.spare5.forEach(item => {
				spare5 += item + ","
			})

			var url = 'replacePost/add';
			var record = {
				project_id: this.ruleForm.spare5[this.ruleForm.spare5.length - 1],
				city_id: this.ruleForm.city_id,
				post_id: this.ruleForm.post_id,
				staff_ids: this.ruleForm.replace_staff,
				replace_reason: this.ruleForm.replace_reason,
				start_date: this.ruleForm.start_date,
				end_date: this.ruleForm.end_date,
				replace_days: this.ruleForm.replace_days,
				day_price: this.ruleForm.day_price,
				total_amount: this.ruleForm.total_amount,
				examineDetailsList: this.ruleForm.examineDetailsList,
				applicant_id: this.$globals.user.staff_id,
				replace_type: this.ruleForm.replace_type == "代岗" ? "1" : "2",
			};
			var data = await this.$globals.AxiosPost(url, record);
			if (data === '-2000') {
				this.$message.error('服务器未响应！请稍后重试');
			} else {
				var code = data.code;
				var data = data.data;
				if (code === '200') {
					this.$message.success(data);
					this.Return();
				} else {
					this.$message.warning(data);
				}
			}
		},
		//修改
		// UpdateAuditor() {
		// 	this.$refs["ruleForm"].validate((valid) => {
		// 		if (valid) {
		// 			this.ruleForm.examineDetailsList = [];
		// 			this.dialogAuditorVisible = true;
		// 			this.$refs['SelectAuditor'].initialize();
		// 		} else {
		// 			console.log('error submit!!');
		// 			return false;
		// 		}
		// 	});
		// },
		async UpdateAuditor() {
			var spare5 = "";
			this.ruleForm.spare5.forEach(item => {
				spare5 += item + ","
			})

			var url = 'replacePost/modify';
			var record = {
				id: this.ruleForm.id,
				project_id: this.ruleForm.spare5[this.ruleForm.spare5.length - 1],
				spare5: spare5,
				city_id: this.ruleForm.city_id,
				post_id: this.ruleForm.post_id,
				replace_staff: this.ruleForm.replace_staff,
				replace_reason: this.ruleForm.replace_reason,
				start_date: this.ruleForm.start_date,
				end_date: this.ruleForm.end_date,
				replace_days: this.ruleForm.replace_days,
				day_price: this.ruleForm.day_price,
				total_amount: this.ruleForm.total_amount,
				examineDetailsList: this.ruleForm.examineDetailsList,
				applicant_id: this.$globals.user.staff_id,
				replace_type: this.ruleForm.replace_type == "代岗" ? "1" : "2",
			};
			var data = await this.$globals.AxiosPost(url, record);
			if (data === '-2000') {
				this.$message.error('服务器未响应！请稍后重试');
			} else {
				var code = data.code;
				var data = data.data;
				if (code === '200') {
					this.$message.success(data);
					this.Return();
				} else {
					this.$message.warning(data);
				}
			}
		},
		resetForm(formName) {
			this.$refs[formName].resetFields();
		},
		Return() {
			this.dialogAuditorVisible = false;
			this.$parent.Return();
		}
	},
	created() {
		this.ruleForm = this.$parent.ruleForm;
	},
	watch: {
		"ruleForm.replace_staff"(newValue) {
			this.object.staff_id = newValue;
		}
	}
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// Dgsq_add.vue?6fce9e81